import { render } from "./SalesTabInvoice.vue?vue&type=template&id=1924087e"
import script from "./SalesTabInvoice.vue?vue&type=script&lang=js"
export * from "./SalesTabInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__